import { render, staticRenderFns } from "./MaterialBankView.vue?vue&type=template&id=776f69a6&"
import script from "./MaterialBankView.vue?vue&type=script&lang=ts&"
export * from "./MaterialBankView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports